import React, { Component } from "react";
import Page from "../shared/Page";
import PropTypes from "prop-types";

class PrivacyPage extends Component {
	componentDidMount() {
		(function(d, s, id) {
			var js,
				tjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) return;
			js = d.createElement(s);
			js.id = id;
			js.src = "https://app.termly.io/embed-policy.min.js";
			tjs.parentNode.insertBefore(js, tjs);
		})(document, "script", "termly-jssdk");
	}
	render() {
		return (
			<Page title="Privacy">
				<div name="termly-embed" data-id="97cca358-ed93-450e-bad8-9fe66b2fecb1" data-type="iframe"></div>
			</Page>
		);
	}
}
PrivacyPage.propTypes = {
	match: PropTypes.object,
};

export default PrivacyPage;
